/**
 * Legacy TicketsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.ticketsApi`) keep resolving.
 *
 * The actual TicketsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/tickets/tickets-api.service.ts
 */
angular.module("acme.common.service.ticketsApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
